// $( ".sf-field-taxonomy-document_type" ).append( $( "<div class='show-more'>Show more</div>" ) );

// $(".side-bar .show-more").click(function() {
//   $(".sf-field-taxonomy-document_type ul").toggleClass("open");

//   if($(".sf-field-taxonomy-document_type ul").hasClass("open")){
//     $(".side-bar .show-more").text( "Show less" );
//   } else {
//     setTimeout(
//       function() 
//       {
//         $(".side-bar .show-more").delay(1000).text( "Show more" );
//       }, 700);
//   }
// });

$(".sf-field-taxonomy-products > ul > li > input[type='checkbox']").remove();

function openAllSfLevels() {
  $(".sf-level-0").addClass("opened");
  $(".sf-level-0 .children").addClass("active");
}

openAllSfLevels();

$(".sf-field-taxonomy-products > ul > li > .sf-label-checkbox").click(function (event){
  event.preventDefault();
  if ($(this).parent().hasClass("opened")) {
    $(this).parent().removeClass("opened");
    $(this).parent().find(".children").removeClass("active");

  } else {
    $(this).parent().addClass("opened");
    $(this).parent().find(".children").addClass("active");
  }
});

function openMobileFilter(){
  $(".sf-level-0").addClass("opened");
  $(".children").addClass("active");
  setTimeout(function() { 
    $(".results").css({
      "display": "none"
    });
    $(".button-wrapper").css("display", "block");
    window.scrollTo(0, 0);
  }, 100);
  setTimeout(function() { 
    $(".filter-button.close").css("display", "block");
  }, 300);
  $(".side-bar").addClass("open");
  $( ".sf-field-taxonomy-products, .sf-field-taxonomy-languages, .sf-field-taxonomy-document_type" ).animate({
    left: "0"
  }, 200);
}

function closeMobileFilter(){
  $(".sf-level-0").removeClass("opened");
  $(".children").removeClass("active");
  $(".results").css({
    "display": "block"
  });
  $(".filter-button.close").css("display", "none");
  $(".button-wrapper").css("display", "none");
  $(".side-bar").removeClass("open");
  $( ".sf-field-taxonomy-products, .sf-field-taxonomy-languages, .sf-field-taxonomy-document_type" ).css("left", "-600px");
  setTimeout(function() { 
  window.scrollTo(0, 0);
  }, 100);
}

$(".filter-button").click(function() {
  if($(".side-bar").hasClass("open")){
    closeMobileFilter();
  } else {
    openMobileFilter();
  }
});

$(document).ready(function() {
  if (window.location.href.indexOf("_sft") > -1) {
    $(".remove-filters").css("display", "inline");
  }
});
$(document).on("sf:ajaxstart", ".searchandfilter", function(){
  if (window.location.href.indexOf("_sft") > -1) {
    $(".remove-filters").css("display", "inline");
  }
});

$(document).on("sf:ajaxfinish", ".searchandfilter", function(){
  if (window.location.href.indexOf("_sft") > -1) {
    $(".remove-filters").css("display", "inline");
  }
  openAllSfLevels();
});

$(".sf-input-checkbox").on('click', function(e) {
  if($('.sf-input-checkbox').is(":checked")){
    console.log("is checked");
  dataLayer.push({
    event: 'filterChecked',
    filterValue: ($(this).val())

  });
  }
});
